"use client";

import { cn, Icon, KyanIcon, TabItem, Tabs, Typography } from "@kyan/ui";
import { usePathname, useRouter } from "next/navigation";

import { routes } from "#/config/routes";
import { useTopBannerFeatureFlag } from "#/hooks/featureFlags/useTopBannerFeatureFlag";

const renderLabel = (label: string, icon: KyanIcon) => {
  return (
    <div className="flex items-center justify-center gap-2">
      <Icon name={icon} />
      <Typography>{label}</Typography>
    </div>
  );
};

const tabs: TabItem[] = [
  {
    id: routes.portfolio.index,
    label: renderLabel("Portfolio", "portfolio"),
  },
  {
    id: routes.options(),
    label: renderLabel("Options", "options"),
  },
  {
    id: routes.perps,
    label: renderLabel("Perps", "candles"),
  },
];

export const Navigation: React.FC = () => {
  const { showTopBanner } = useTopBannerFeatureFlag();
  const router = useRouter();
  const pathname = usePathname();

  const handleChange = (id: string) => {
    router.push(id);
  };

  const value = pathname.startsWith(routes.portfolio.index)
    ? routes.portfolio.index
    : pathname;

  return (
    <nav
      className={cn("pt-16", {
        "pt-34": showTopBanner,
      })}
    >
      <Tabs
        items={tabs}
        value={value}
        variant="primary"
        className="w-full"
        itemClassName="text-xs whitespace-nowrap h-16"
        onChange={handleChange}
      />
    </nav>
  );
};
